import React, { FC, ReactElement } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { clsx } from 'clsx';
import { Checkbox, CheckboxProps, FormControlLabel, FormGroup, Typography } from '@mui/material';
import Text from '../text';
// Resources
import SvgIcon from '../icons/SvgIcon';
import { IconAxel } from '../../resources/images';

interface RadioLabelProps extends CheckboxProps {
    description?: string;
    errorText?: string;
    labelClassName?: string;
    containerClassName?: string;
}

const RadioLabel: FC<RadioLabelProps> = (props): ReactElement => {
    const { value, onChange, onSubmit, name, errorText, containerClassName, labelClassName, hidden, ...rest } = props;
    const classes = useStyles();

    return (
        <>
            <FormGroup className={clsx(classes.formGroup, containerClassName)}>
                <FormControlLabel
                    disabled={rest.disabled}
                    label={
                        <Typography
                            variant="overline"
                            className={clsx(classes.label, labelClassName, rest.disabled ? classes.labelDisabled : '')}
                            dangerouslySetInnerHTML={{
                                // eslint-disable-next-line react/destructuring-assignment
                                __html: props.title,
                            }}
                        />
                    }
                    control={
                        <Checkbox
                            {...rest}
                            icon={<SvgIcon icon={IconAxel.Radio} />}
                            checkedIcon={<SvgIcon icon={IconAxel.RadioChecked} />}
                        />
                    }
                    // control={<Checkbox {...rest} size="small" />}
                    onChange={onChange}
                    name={name}
                    className={clsx(classes.radioLabel, hidden && classes.radioHidden)}
                />
            </FormGroup>

            {props.description && (
                <Text.Description14 text={props.description} customColor="grey" className={classes.radioDescription} />
            )}
        </>
    );
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        radioLabel: {
            marginRight: 0,
            '& *': {
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
            },
            '& .MuiCheckbox-root:hover': {
                backgroundColor: 'transparent',
            },
            // '& .Mui-checked .MuiSvgIcon-root': {
            //     fill: theme.palette.secondary.light,
            // },
        },
        radioHidden: {
            contentVisibility: 'hidden',
        },
        radioDescription: {
            marginBottom: 16,
        },
        formGroup: {
            flexDirection: 'row',
            alignItems: 'center',
            flexWrap: 'nowrap',
        },
        label: {
            marginLeft: 8,
            fontSize: 16,
            color: theme.palette.colors.text.accent,
            userSelect: 'none',
        },
        labelDisabled: {
            color: `${theme.palette.colors.text.label}!important`,
        },
    }),
);

export default RadioLabel;
